/* eslint-disable */
import { useMemo } from "react";
import {
  useDictionary,
  useOLAPTransformer,
  OLAPTransformerResult,
  OLAPTransformerOptions,
  useParameter,
} from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import { SLIDE_NUMBER } from "../constants";

const ROW_AXIS = "calendar.default";
const UNITS_AXIS = "units.default";
const COLUMN_AXIS = "commodities.default";

export function useTableData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, rowsDict] = useDictionary(dictionaryService, "calendar-origin");
  const [commoditiesDisplay] = useParameter<number[]>("@commodities_display");
  const [itemsColumns, columnsDict] = useDictionary(dictionaryService, "slides-commodities");
  const [itemsColumnsDisplay] = useDictionary(dictionaryService, "slides-commodities-display", commoditiesDisplay!, {
    slide: SLIDE_NUMBER,
    business_unit: 1,
  });
  const [, unitsDict] = useDictionary(dictionaryService, "f_units_ap_official_prices", undefined, {
    attributes: "",
    slide: SLIDE_NUMBER,
  });

  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if ([olapResult, columnsDict, rowsDict, itemsColumns, itemsColumnsDisplay, unitsDict].some((x) => !Boolean(x))) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsNameProxy: new Map([
        [
          `${COLUMN_AXIS}.name`,
          (id: unknown, lcid: number) => {
            const itemDisplay = itemsColumnsDisplay?.find((x) => Number(x.getValue("olap_commodity")) === Number(id));
            const item = itemsColumns?.find((x) => Number(x.id) === Number(id));

            return (itemDisplay || item)?.getValue("name") || { [lcid]: "" };
          },
        ],
      ]),
      attrsDictionaries: new Map([
        [COLUMN_AXIS, columnsDict],
        [ROW_AXIS, rowsDict],
        [UNITS_AXIS, unitsDict],
      ]) as ReadonlyMap<string, Dictionary>,
    } as OLAPTransformerOptions;
  }, [olapResult, columnsDict, rowsDict, itemsColumns, itemsColumnsDisplay]);

  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${COLUMN_AXIS}.name`, `${COLUMN_AXIS}.id`, `${UNITS_AXIS}.id`, `${UNITS_AXIS}.name`],
      rows: [`${ROW_AXIS}.name`, `${ROW_AXIS}.id`, `${UNITS_AXIS}.id`, `${UNITS_AXIS}.name`],
      cellData: {
        inCell: ["Measures.value"],
        attributes: [
          `${COLUMN_AXIS}.name`,
          `${ROW_AXIS}.name`,
          `${COLUMN_AXIS}.id`,
          `${ROW_AXIS}.id`,
          `${UNITS_AXIS}.id`,
          `${UNITS_AXIS}.name`,
        ],
      },
    };
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
